module.exports = __webpack_public_path__ + "static/media/guanyinshanicon.ec465531.webp";